// AUTO-GENERATED by scripts/apply-marzipano-hotspots.ts
export const generatedSceneLabelsVi: Record<string, string> = {
  "scenes.flycam-cao-toan-khu-37-5-ha": "Flycam cao — toàn khu 37,5 ha",
  "scenes.flycam-cao-2-benh-vien": "Flycam cao — 2 bệnh viện",
  "scenes.canh-quan-noi-khu-loi-di-giua-2-bv": "Cảnh quan nội khu - lối đi giữa 2 BV",
  "scenes.chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh": "Chào mừng Quý khách đến với Những dấu ấn hình thành & phát triển khu y tế kỹ thuật cao TP. Hồ Chí Minh",
  "scenes.tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh": "Thăm quan Những dấu ấn hình thành & phát triển khu y tế kỹ thuật cao TP. Hồ Chí Minh",
  "scenes.sanh-chinh": "Sảnh chính",
  "scenes.quay-tiep-nhan-le-tan": "Quầy tiếp nhận - lễ tân",
  "scenes.phong-cho-kham-chung": "Phòng chờ khám chung",
  "scenes.hanh-lang-khu-kham-ngoai-tru": "Hành lang khu khám ngoại trú",
  "scenes.phong-kham-quoc-te-van-phong-don-khach-campuchia": "Phòng khám Quốc tế - Văn phòng đón khách Campuchia",
  "scenes.phong-benh-vip-suite": "Phòng bệnh VIP  - Suite",
  "scenes.phong-benh-noi-tru": "Phòng bệnh nội trú",
  "scenes.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may": "Sảnh chính – Khu vực Quầy thông tin, Thu ngân, Nhà thuốc & Thang máy",
  "scenes.khoa-cap-cuu-gia-an-115": "Khoa Cấp cứu Gia An 115",
  "scenes.khoa-kham-benh-hanh-lang-phong-kham": "Khoa Khám bệnh — hành lang - phòng khám",
  "scenes.khoa-chan-doan-hinh-anh-tham-do-chuc-nang": "Khoa Chẩn đoán hình ảnh & Thăm dò chức năng",
  "scenes.khoa-vltl": "Khoa VLTL",
  "scenes.phong-mo": "Phòng mổ",
  "scenes.lim-premier-clinic-vip-sanh-phong-kham": "Lim Premier Clinic (VIP) - Sảnh phòng khám",
  "scenes.phong-benh-tieu-bieu-phong-vip": "Phòng bệnh tiêu biểu - Phòng VIP",
  "scenes.phong-benh-tieu-bieu-phong-don": "Phòng bệnh tiêu biểu - Phòng đơn",
  "scenes.phong-benh-tieu-bieu-phong-doi": "Phòng bệnh tiêu biểu - Phòng đôi"
};

export const generatedSceneLabelsEn: Record<string, string> = {
  "scenes.flycam-cao-toan-khu-37-5-ha": "Aerial view — full 37.5 ha campus",
  "scenes.flycam-cao-2-benh-vien": "Aerial view — two hospitals",
  "scenes.canh-quan-noi-khu-loi-di-giua-2-bv": "Campus landscape — walkway between hospitals",
  "scenes.chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh": "Welcome — development milestones",
  "scenes.tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh": "Tour — development milestones",
  "scenes.sanh-chinh": "CIH main lobby",
  "scenes.quay-tiep-nhan-le-tan": "CIH reception",
  "scenes.phong-cho-kham-chung": "CIH general waiting area",
  "scenes.hanh-lang-khu-kham-ngoai-tru": "CIH outpatient corridor",
  "scenes.phong-kham-quoc-te-van-phong-don-khach-campuchia": "CIH international clinic — Cambodia guest office",
  "scenes.phong-benh-vip-suite": "CIH VIP suite room",
  "scenes.phong-benh-noi-tru": "CIH inpatient room",
  "scenes.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may": "Gia An 115 main lobby — info, cashier, pharmacy & lifts",
  "scenes.khoa-cap-cuu-gia-an-115": "Gia An 115 emergency",
  "scenes.khoa-kham-benh-hanh-lang-phong-kham": "Gia An 115 outpatient — corridor & clinics",
  "scenes.khoa-chan-doan-hinh-anh-tham-do-chuc-nang": "Gia An 115 imaging & functional diagnostics",
  "scenes.khoa-vltl": "Gia An 115 physiotherapy (VLTL)",
  "scenes.phong-mo": "Gia An 115 operating room",
  "scenes.lim-premier-clinic-vip-sanh-phong-kham": "Lim Premier Clinic (VIP) lobby",
  "scenes.phong-benh-tieu-bieu-phong-vip": "Gia An 115 showcase — VIP room",
  "scenes.phong-benh-tieu-bieu-phong-don": "Gia An 115 showcase — single room",
  "scenes.phong-benh-tieu-bieu-phong-doi": "Gia An 115 showcase — twin room"
};
